<template>
    <!-- 핀이 많으면 상세 창이 길어지므로, 표 높이를 상세 창에 남는 높이(maxHeight)로 제한하고 표 안에서만 스크롤한다. -->
    <v-data-table v-bind="{ items, headers }" :style="{ '--pins-max-height': maxHeight }" fixed-header :items-per-page="-1" disable-pagination disable-sort hide-default-footer class="v-sheet--outlined nshop-order-view-section nshop-order-view-pins" :class="{ 'has-scroll': hasScroll, 'is-mobile': $vuetify.breakpoint.mobile }" ref="table" no-data-text="발급된 상품권이 없습니다">
        <template v-if="label" #top>
            <div class="table-label px-1 white">
                상품권<template v-if="items.length"> · {{ items.length }}장 · 충전완료 {{ gainedCount }} / 미충전 {{ items.length - gainedCount }}</template>
            </div>
        </template>
        <template v-for="(header, index) in headers.filter((h) => h.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value, item)" /> </template>
    </v-data-table>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";
import { initDataTableHeaders } from "@/assets/lib";

export default {
    props: {
        order: { type: Object, default: () => ({}) },
        // 표 위 '상품권 · N장 · 충전완료 …' 라벨. 핀 번호 창처럼 제목줄에 요약을 따로 보이는 곳은 끈다.
        label: { type: Boolean, default: true },
        // PC 에서 표 높이 상한. 기본값은 주문 상세 창에서 위쪽 주문·회원·결제 정보를 뺀 높이다.
        maxHeight: { type: String, default: "max(240px, calc(90vh - 450px))" },
    },
    data: () => ({
        // 표가 높이 제한을 넘어 스크롤바가 생겼는지. 이때만 마지막 칸 오른쪽에 스크롤바와의 경계선을 그린다.
        hasScroll: false,
    }),
    computed: {
        items() {
            return this.order?.pins || [];
        },
        gainedCount() {
            return this.items.filter((pin) => pin?.isGained).length;
        },
        headers() {
            return initDataTableHeaders([
                { text: "PIN", value: "pno" },
                { text: "권종", value: "faceamt", align: "end", formatterType: "number", formatterSuffix: "원" },
                { text: "충전여부", value: "isGained", align: "center", formatter: (v) => (v ? "충전완료" : "미충전") },
                { text: "발급일시", value: "issuedAt", formatterType: "datetime" },
            ]);
        },
    },
    watch: {
        items() {
            this.$nextTick(this.checkScroll);
        },
        // 모바일 전환 시 높이 제한이 풀리고 걸리므로 스크롤 여부를 다시 잰다.
        "$vuetify.breakpoint.mobile"() {
            this.$nextTick(this.checkScroll);
        },
    },
    mounted() {
        this.$nextTick(this.checkScroll);
        window.addEventListener("resize", this.checkScroll);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.checkScroll);
    },
    methods: {
        checkScroll() {
            let wrapper = this.$refs.table?.$el?.querySelector(".v-data-table__wrapper");
            this.hasScroll = !!wrapper && wrapper.scrollHeight > wrapper.clientHeight;
        },
    },
};
</script>

<style lang="scss" scoped>
// 표 높이를 maxHeight 로 제한한다.
// 모바일(전체 화면 창)은 정보가 세로로 쌓여 표 자리가 거의 없으므로 제한하지 않고 창 본문 스크롤 하나로 본다.
.nshop-order-view-pins:not(.is-mobile) ::v-deep .v-data-table__wrapper {
    max-height: var(--pins-max-height);
    overflow-y: auto;
}
// 고정 머리글은 칸마다 흰 배경으로 겹쳐 그려져, 옆 칸이 첫 칸의 border-right 를 덮는다.
// 칸 사이 세로선을 각 칸 안쪽 그림자로 그려 덮이지 않게 한다(아래 선은 Vuetify fixed-header 의 것을 유지).
.nshop-order-view-pins ::v-deep thead th:not(:last-child) {
    border-right: 0 !important;
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.12), inset 0 -1px 0 rgba(0, 0, 0, 0.12) !important;
}
// 스크롤바가 있을 때 표와 스크롤바 사이 경계선. 없을 때 그리면 바깥 테두리와 겹쳐 두 줄이 된다.
.nshop-order-view-pins.has-scroll ::v-deep {
    thead th:last-child {
        box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.12), inset 0 -1px 0 rgba(0, 0, 0, 0.12) !important;
    }
    tbody td:last-child {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }
}
</style>
